module.exports = __webpack_public_path__ + "img/terImg8.165587d0.png";